<template>
  <b-form @submit.prevent="onSubmit">

    <b-form-group :label="$t('Name')" label-for="name">
      <b-form-input id="name" v-model="planData.name" autofocus :state="errors && ('name' in errors) ? false : null"
        trim autocomplete="off" placeholder="" />
      <b-form-invalid-feedback v-if="errors && ('name' in errors)" :state="errors && ('name' in errors) ? false : null">
        {{ errors.name[0] }}
      </b-form-invalid-feedback>
    </b-form-group>


    <!-- device -->
    <b-form-group :label="$t('Device')" label-for="device" :state="null">


      <!-- <v-select
          @input="set_name($event),refilterAreas()" label="name" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        :options="devicesOptions" :clearable="true" input-id="device"

         /> -->
      <v-select v-model="planData.device_id" label="name" :reduce="val => val.device_id"
        :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" :options="devicesOptions" :clearable="true"
        input-id="device" @input="set_name($event),refilterAreas($event)" />

      <!-- <v-select
         @input="set_name($event),refilterAreas()"
          v-model="planData.device_id"
                  label="name" :reduce="val => val.device_id"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="devicesOptions"
                   :clearable="true" input-id="device"
        /> -->

      <b-form-invalid-feedback v-if="errors && ('device_id' in errors)"
        :state="errors && ('device_id' in errors) ? false : null">
        {{ errors.device_id[0] }}
      </b-form-invalid-feedback>
    </b-form-group>


    <!-- Camp -->
    <b-form-group :label="$t('Camp')" label-for="camp" :state="null">
      <v-select v-model="planData.camps" label="name" multiple :close-on-select="false" :reduce="val => val.geofence_id"
        :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" :options="campsOption" :clearable="false"
        input-id="camp" />
      <b-form-invalid-feedback v-if="errors && ('camps' in errors)"
        :state="errors && ('camps' in errors) ? false : null">
        {{ errors.camps[0] }}
      </b-form-invalid-feedback>
    </b-form-group>


    <b-row>
      <b-col cols="6">
        <!-- leave camp time -->
        <b-form-group :label="$t('Leave Camp Time')" label-for="leave-camp" :state="null">
          <flat-pickr v-model="planData.camp_leave" dateFormat="H:m:s" class="form-control"
            :class="{ 'is-invalid': errors && ('camp_leave' in errors) }" :config="flatPickerConfig"
            placeholder="HH:MM:SS" />
          <b-form-invalid-feedback v-if="errors && ('camp_leave' in errors)"
            :state="errors && ('camp_leave' in errors) ? false : null">
            {{ errors.camp_leave[0] }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <!-- back camp time -->
        <b-form-group :label="$t('Back Camp Time')" label-for="back-camp" :state="null">
          <flat-pickr v-model="planData.camp_back" :state="null" class="form-control"
            :class="{ 'is-invalid': errors && ('camp_back' in errors) }" :config="flatPickerConfig"
            placeholder="HH:MM:SS" />
          <b-form-invalid-feedback v-if="errors && ('camp_back' in errors)"
            :state="errors && ('camp_back' in errors) ? false : null">
            {{ errors.camp_back[0] }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>

      <b-col cols="12">
        <label>{{ $t('Irrigation Area') }}</label>


        <irrigation-form-repeater :items.sync="IrrigationAreaItems" :options="irrigationAreasOption">
          <template v-slot:error>
            <b-form-invalid-feedback v-if="errors && ('irrigation' in errors)"
              :state="errors && ('irrigation' in errors) ? false : null">
              {{ errors.irrigation[0] }}
            </b-form-invalid-feedback>
          </template>
        </irrigation-form-repeater>
      </b-col>



      <b-col cols="12">

        <b-form-group :label="$t('work days')" label-for="work_days" :state="null">
          <b-form-checkbox-group v-model="planData.work_days"
            :options="daysOptions.map(i => ({ text: $t(i.text), 'value': i.value }))" name="flavour-1a">
          </b-form-checkbox-group>
          <b-form-invalid-feedback v-if="errors && ('work_days' in errors)"
            :state="errors && ('work_days' in errors) ? false : null">
            {{ errors.work_days[0] }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>

      <b-col cols="12">
        <label>{{ $t('fill areas') }}</label>

        <v-select v-model="planData.fill_areas" label="name" multiple :close-on-select="false"
          :reduce="val => val.geofence_id" :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
          :options="waterAreasOption" :clearable="false" input-id="fill_area" if />
        <b-form-invalid-feedback v-if="errors && ('fill_areas' in errors)"
          :state="errors && ('fill_areas' in errors) ? false : null">
          {{ errors.fill_areas[0] }}
        </b-form-invalid-feedback>
      </b-col>

      <b-col cols="12">
        <label>{{ $t('tanks areas') }}</label>
        <area-form-repeater :items.sync="TanksAreaItems" :options="tankAreasOption">
          <template v-slot:error>
            <b-form-invalid-feedback v-if="errors && ('tanks' in errors)"
              :state="errors && ('tanks' in errors) ? false : null">
              {{ errors.tanks[0] }}
            </b-form-invalid-feedback>
          </template>
        </area-form-repeater>
      </b-col>

    </b-row>

    <!-- Form Actions -->
    <div class="d-flex mt-2">
      <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mr-2" type="submit">
        {{ $t('Save') }}
      </b-button>
    </div>
  </b-form>
</template>

<script>

import {
  BCol, BRow, BFormGroup, BFormInvalidFeedback, BFormRadioGroup, BFormCheckboxGroup,
  BButton, BForm, BFormInput, BFormSelect, BFormSelectOption

} from 'bootstrap-vue'
import AreaFormRepeater from '@/components/form/AreaFormRepeater'
import IrrigationFormRepeater from '@/components/form/IrrigationFormRepeater'
import { onUnmounted, ref } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'
import store from '@/store'
import formGetLinkedOptions from '@/views/modules/api/formGetLinkedOptions'

export default {
  name: 'GardenPlanForm',
  components: {
    IrrigationFormRepeater,
    AreaFormRepeater, BButton, BFormCheckboxGroup,
    flatPickr, vSelect, BForm, BFormInput,
    BCol, BRow, BFormGroup, BFormInvalidFeedback, BFormRadioGroup, BFormSelect, BFormSelectOption
  },
  props: {
    errors: {
      type: Object | undefined,
      required: true
    },
    planData: {
      type: Object,
      required: true
    },
    FillAreaItems: {
      type: Array,
      required: true
    },
    IrrigationAreaItems: {
      type: Array,
      required: true
    },
    TanksAreaItems: {
      type: Array,
      required: true
    },

    onSubmit: {
      type: Function,
      required: true
    }
  },
  directives: {
    Ripple,
  },
  setup(props) {

    const user = store.getters['auth/user']
    const device_geofences_ids = ref()

    // Register module
    if (!store.hasModule('formOptions'))
      store.registerModule('formOptions', formGetLinkedOptions)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule('formOptions'))
        store.unregisterModule('formOptions')
    })

    const campsOption = ref([])
    const campsOption_org = ref([])

    const waterAreasOption = ref([])
    const waterAreasOption_org = ref([])

    const tankAreasOption = ref([])
    const tankAreasOption_org = ref([])

    const irrigationAreasOption = ref([])
    const irrigationAreasOption_org = ref([])

    const devicesOptions = ref([])


    const daysOptions = [
      { text: 'Saturday', value: 'Saturday' },
      { text: 'Sunday', value: 'Sunday' },
      { text: 'Monday', value: 'Monday' },
      { text: 'Tuesday', value: 'Tuesday' },
      { text: 'Wednesday', value: 'Wednesday' },
      { text: 'Thursday', value: 'Thursday' },
      { text: 'Friday', value: 'Friday' },
    ]

    const flatPickerConfig = {
      enableTime: true,
      noCalendar: true,
      time_24hr: true,
      dateFormat: "H:i:S",

    }


    const setOriginalOptions = area => {
      switch (area.category) {
        case 'CAMP_AREA': campsOption_org.value.push(area); break
       
      }

    }


    const setOptions = area => {
      switch (area.category) {
        case 'CAMP_AREA': campsOption.value.push(area); break
      
      }

    }


    const set_name = (e) => {
        
        if(e != undefined){
          const device = devicesOptions.value.find(d => d.device_id === e)

props.planData.name = `${device.name} خطة عمل تانكر `
props.planData.device_id = device.device_id
        }
      
    }

    const refilterAreas = (selected_id) => {
      device_geofences_ids.value = []
     if(selected_id !=undefined){
    //  let d_id = props.planData.device_id

     
      store.dispatch('formOptions/getItemsLinkedTo', {
        deviceId: selected_id,
        type: 'deviceGeofences',
      }).then(res => {
        //display areas that link to selected device
        device_geofences_ids.value = res.data.ids;
        irrigationAreasOption.value = irrigationAreasOption_org.value.filter((i) => device_geofences_ids.value.includes(i.geofence_id))
        tankAreasOption.value = tankAreasOption_org.value.filter((i) => device_geofences_ids.value.includes(i.geofence_id))
        waterAreasOption.value = waterAreasOption_org.value.filter((i) => device_geofences_ids.value.includes(i.geofence_id))
        campsOption.value = campsOption_org.value.filter((i) => device_geofences_ids.value.includes(i.geofence_id))
      })

     }else{
      irrigationAreasOption.value = irrigationAreasOption_org.value
        tankAreasOption.value = tankAreasOption_org.value
        waterAreasOption.value = waterAreasOption_org.value
        campsOption.value = campsOption_org.value

     }
      

    }
    
    const setCampOptions =(cat)=>{
      store.dispatch('formOptions/getLinkedOptions', {
      user: user.id,
      type: 'geofence',
      cols: 'geofence_id,name,category',
      
    }).then(res => {
      res.data.data.map(a => {
       setOptions(a)
       setOriginalOptions(a)
      }
      )     

    }

    ).catch(reason => { })
    }

    const findByCategorey =(cat)=>{
       
      store.dispatch('formOptions/getLinkedOptions', {
      user: user.id,
      type: 'geofence',
      cols: 'geofence_id,name,category',
      typesSlug:[cat]
    }).then(res => {
            
      fillOptionsByCategory(cat,res.data.data)

    }

    ).catch(reason => { })
      
    }
    const fillOptionsByCategory =(cat,area)=>{

      switch(cat){
       
        case 'FILL_AREA':
           waterAreasOption.value=area;
           waterAreasOption_org.value=area;
            break
        case 'TANK_AREA':
           tankAreasOption.value=area; 
           tankAreasOption_org.value=area;
          break
        case 'IRRIGATION_AREA': 
         irrigationAreasOption.value=area; 
         irrigationAreasOption_org.value=area; 
         break

      }
    }

    ['IRRIGATION_AREA','FILL_AREA','TANK_AREA'].map(i=> findByCategorey(i))
    setCampOptions()
   
   


    store.dispatch('formOptions/getLinkedOptions', {
      user: user.id,
      type: 'device',
      cols: 'device_id,name'
    }).then(res => devicesOptions.value = res.data.data).catch(reason => { })


    return {
      daysOptions,
      flatPickerConfig,
      campsOption,
      waterAreasOption,
      tankAreasOption,
      irrigationAreasOption,
      irrigationAreasOption_org,
      devicesOptions,
      device_geofences_ids,
      set_name,
      refilterAreas

    }

  }
}
</script>

<style scoped>

</style>
